import { render, staticRenderFns } from "./imprimirRotulo.vue?vue&type=template&id=44677265"
import script from "./imprimirRotulo.ts?vue&type=script&lang=js&external"
export * from "./imprimirRotulo.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44677265')) {
      api.createRecord('44677265', component.options)
    } else {
      api.reload('44677265', component.options)
    }
    module.hot.accept("./imprimirRotulo.vue?vue&type=template&id=44677265", function () {
      api.rerender('44677265', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/rotulopersonalizado/imprimirRotulo.vue"
export default component.exports